export default function RedFlag(props) {
  const style = {
    fill: "#eb2f06",
    ...props.style,
  };

  return (
    <svg
      width={props.size ? props.size : "1em"}
      height={props.size ? props.size : "1em"}
      version="1.1"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      className="red-flag"
    >
      {props.remove ? (
        <path
          d="m88.367 20.406h-22.754v-6.1211c0-3.9805-3.1641-7.1445-7.1445-7.1445l-16.938 0.003906c-3.9805 0-7.1445 3.1641-7.1445 7.1445v6.1211l-22.754-0.003906c-1.7344 0-3.0625 1.3281-3.0625 3.0625s1.3281 3.0625 3.0625 3.0625h6.0195l4.2852 58.777c0.30469 4.1836 3.8789 7.5508 8.1641 7.5508h39.695c4.2852 0 7.8555-3.2656 8.1641-7.5508l4.3867-58.777h6.0195c1.7344 0 3.0625-1.3281 3.0625-3.0625s-1.3281-3.0625-3.0625-3.0625zm-47.855-6.1211c0-0.51172 0.51172-1.0195 1.0195-1.0195h16.938c0.51172 0 1.0195 0.51172 1.0195 1.0195v6.1211h-18.977z"
          style={style}
        />
      ) : (
        <path
          d="m91.875 44.688l-16.875-18.125c-0.9375-0.9375-1.25-2.5-0.3125-3.75l10.625-18.438c1.25-1.875-0.3125-4.375-2.8125-4.375h-72.188c-1.875 0-3.4375 1.875-3.125 3.75l8.4375 46.25 8.4375 47.5c0.3125 1.5625 1.5625 2.5 3.125 2.5h6.25c1.875 0 3.4375-1.875 3.125-3.75l-7.8125-42.5c-0.3125-1.875 1.25-3.75 3.125-3.75h57.812c2.5 0 4.0625-3.125 2.1875-5.3125z"
          style={style}
        />
      )}
    </svg>
  );
}
